import getMemberIdBySuffix from 'utils/pivot/member/getMemberIdBySuffix'

export function updateMembers(members, formValues) {
  for (const key in formValues) {
    const [inputName, suffix] = key.split('_')
    const isHeightInput = inputName.startsWith('height')

    if (inputName === 'weight' || isHeightInput) {
      const ids = getMemberIdBySuffix(suffix)

      const member = members.find(person => person.id === ids.id)

      if (isHeightInput) {
        member.height = member.height || {}
        member.height[inputName.slice(-2) === 'ft' ? 'feet' : 'inches'] = formValues[key]
      } else {
        member[inputName] = formValues[key]
      }
    }
  }

  return members
}
